import React, { useEffect, useState } from "react";
import {
	useTheme,
	Box,
	Alert,
	Backdrop,
	Snackbar,
	CircularProgress,
} from "@mui/material";
// import NodesView from "../../../components/NodesView";
import HierarchicalTree from "../../../components/HierarchicalTree";
import { useNavigate } from "react-router-dom";
import { RoutesUrls } from "../../../Services/Routes/APP";
import { COMMON_API_URLS } from "../../../Services/Routes/API";
import { headersGet } from "../../../Services/API";
import { ROLE_METHODS } from "../../../common/functions";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";

const TreeView = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const user = useDecodedToken();

	const [loaderOpen, setLoaderOpen] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [alertIcon, setAlertIcon] = useState("error");
	const [alertOpen, setAlertOpen] = useState(false);
	const [nodesTree, setNodesTree] = useState(null);

	const handleAlertClose = () => {
		setAlertOpen(false);
		setAlertMsg("");
		setAlertIcon("error");
	};

	const getNodesViewTree = () => {
		setLoaderOpen(true);
		headersGet(
			COMMON_API_URLS.GET_NODES_TREE(
				ROLE_METHODS.pluralizeRole(ROLE_METHODS.apiBasedRole(user?.role))
			)
		) //pass view_level as plural
			.then((res) => {
				setLoaderOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					setNodesTree(res?.data?.nodes_tree);
				} else {
					setAlertOpen(true);
					setAlertMsg(res?.data?.message);
					setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setLoaderOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
					setAlertOpen(true);
					setAlertMsg(response?.statusText);
					setAlertIcon("error");
				}
			});
	};

	useEffect(() => {
		getNodesViewTree();
	}, []);

	return (
		<>
			<Box
				maxHeight={"100%"}
				maxWidth={"100%"}
				minHeight={"100%"}
				minWidth={"100%"}
				display={"flex"}
				overflow={"hidden"}
				position={"relative"}
			>
				{/* <NodesView tree={nodesTree} /> */}
				<HierarchicalTree tree={nodesTree || []} />
			</Box>
			<Backdrop
				sx={{
					zIndex: theme.zIndex.drawer + 1,
					color: theme.palette.primary.main,
				}}
				open={loaderOpen}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			<Snackbar
				open={alertOpen}
				autoHideDuration={6000}
				onClose={handleAlertClose}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Alert onClose={handleAlertClose} severity={alertIcon}>
					{alertMsg}
				</Alert>
			</Snackbar>
		</>
	);
};

export default TreeView;